import { Helmet } from 'react-helmet';

export const AffiliateHubStructuredData = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Travel Resources & Partners",
    "description": "Discover our trusted travel partners for flights, hotels, tours, and more. Book with confidence using our recommended services.",
    "url": "https://trottingtheworld.com/travel-resources",
    "publisher": {
      "@type": "Organization",
      "name": "Trotting the World",
      "url": "https://trottingtheworld.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://trottingtheworld.com/og-image.png"
      }
    },
    "mainEntity": {
      "@type": "ItemList",
      "name": "Travel Partner Services",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Flights"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Hotels"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Tours"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Car Rentals"
        },
        {
          "@type": "ListItem",
          "position": 5,
          "name": "Travel Insurance"
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};
